<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="procSettingTitle" width="400px" @close="closePopup">
    <el-form slot="content" :model="procInfo" :rules="rules" label-position="top" ref="procInfoForm">
      <el-row>
          <el-form-item :label="labelNameByTree" prop="majorProcTypeName">
            <el-input v-model="procInfo.majorProcTypeName" placeholder="입력해 주세요."></el-input>
          </el-form-item>
      </el-row>
    </el-form>
    <el-row slot="footer" type="flex" justify="center">
      <el-button size="large" type="solid" class="mr-r4" @click="saveCommandData">저장</el-button>
      <el-button size="large" @click="cancelCommandData">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import isNil from 'lodash/isNil';
import clone from 'lodash/clone';
import isUndefined from 'lodash/isUndefined';

export default {
  name: 'WTreeProcTypePopup',
  props: {
    selectPhysicalNode: Object,
    popupType: String,
    editData: Object,
    majorProcTypeId: Number,
  },
  data() {
    return {
      labelNameByTree: '',
      formName: 'procInfoForm',
      procSettingTitle: '중요 프로세스 타입',
      showSearchTool: false,
      params: {
        objId: null,
      },
      procInfo: {
        majorProcTypeName: null,
      },
      rules: {
        majorProcTypeName: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
            message: '필수 정보입니다.',
          },
        ],
      },
    };
  },
  watch: {
    editData: {
      handler(data) {
        this.procInfo = clone(data);
        if (this.popupType === 'ADD') {
          this.procSettingTitle = '중요 프로세스 타입 추가';
        } else {
          this.procSettingTitle = '중요 프로세스 타입 수정';
        }
      },
      deep: true,
    },
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.selectPhysicalNode)) {
          if (this.selectPhysicalNode.depth === 1) {
            this.labelNameByTree = '템플릿 그룹명';
          } else if (this.selectPhysicalNode.depth === 2) {
            if (this.popupType === 'ADD') {
              this.labelNameByTree = '중요 프로세스 타입명';
            } else {
              this.labelNameByTree = '템플릿 그룹명';
            }
          } else {
            this.labelNameByTree = '템플릿 타입명';
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    closePopup() {
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    saveCommandData() {
      const saveParams = clone(this.procInfo);
      const typeId = this.majorProcTypeId;
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          if (this.popupType === 'ADD') {
            if (typeId === -2) {
              saveParams.parentMajorProcTypeId = -1;
            } else {
              saveParams.parentMajorProcTypeId = this.majorProcTypeId;
            }
            ServerSettingAPI.insertMajorProcessType(saveParams).then((response) => {
              if (response.data.success) {
                this.$emit('reload-data', saveParams);
                this.closePopup();
              }
            });
          } else {
            if (typeId === -2) {
              saveParams.majorProcTypeId = -1;
            } else {
              saveParams.majorProcTypeId = this.majorProcTypeId;
            }
            ServerSettingAPI.updateMajorProcessType(saveParams).then((response) => {
              if (response.data.success) {
                this.$emit('reload-data');
                this.closePopup();
              }
            });
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('필수사항을 입력해주세요.'));
        }
      });
    },
    validateNull(rule, value, callback) {
      if (isUndefined(value) || value === '' || isNil(value)) {
        callback(new Error());
      } else {
        callback();
      }
    },
    cancelCommandData() {
      this.closePopup();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/popup/TreeProcTypePopup.vue